<template>
  <div class="batch-stock-list">
    <KTCodePreview v-bind:title="'Danh sách lô sản phẩm'">
      <template v-slot:toolbar>
        <b-overlay
          :show="isDownloading"
          rounded
          opacity="0.6"
          class="d-inline-block"
        >
          <template #overlay>
            <b-spinner variant="light" small type="grow"></b-spinner>
          </template>
          <b-button
            variant="primary"
            size="sm"
            class="font-weight-bolder"
            :disabled="isBusy || isDownloading"
            @click="exportExcel"
          >
            <v-icon small class="text-white">mdi-download</v-icon>
            Xuất Excel
          </b-button>
        </b-overlay>
      </template>
      <template v-slot:preview>
        <div class="wizard-nav-bg">
          <b-col cols="12" class="py-8 custom-card-body">
            <b-row class="mb-5">
              <b-col md="3">
                <div class="date-style">
                  <b-input-group>
                    <date-picker
                      placeholder="Từ"
                      class="form-control form-control-sm"
                      :config="dpConfigs.date"
                      v-model="queryParams.fromDate"
                    ></date-picker>
                  </b-input-group>
                  <span class="ml-1 mr-1"></span>
                  <b-input-group>
                    <date-picker
                      placeholder="Đến"
                      class="form-control form-control-sm"
                      :config="dpConfigs.date"
                      v-model="queryParams.toDate"
                    ></date-picker>
                  </b-input-group>
                </div>
              </b-col>
              <b-col md="3">
                <vue-autosuggest
                  v-model="searchProduct"
                  :suggestions="filteredOptionsProduct"
                  @selected="onSelectedProduct"
                  :limit="10"
                  @input="onInputChangeProduct"
                  :input-props="{
                    id: 'autosuggest__input',
                    placeholder: 'Nhập mã, tên, mã vạch sản phẩm',
                  }"
                  :should-render-suggestions="
                    (size, loading) =>
                      size >= 0 && !loading && searchProduct !== ''
                  "
                  :get-suggestion-value="getSuggestionValue"
                >
                  <div
                    slot-scope="{ suggestion }"
                    style="display: flex; align-items: center"
                  >
                    {{ suggestion.item.productName }}
                  </div>
                </vue-autosuggest>
              </b-col>
              <b-col md="3">
                <BDropdownCustom
                  v-model="storeValues"
                  :options="optionsStore"
                  :placeholder="'cửa hàng'"
                  :searchable="true"
                  :matchKey="['name', 'shortName']"
                  :limit="5"
                />
              </b-col>
              <b-col md="3">
                <b-button-group size="sm">
                  <b-button
                    style="width: 70px"
                    class="font-weight-bolder"
                    variant="primary"
                    @click="onFilter"
                    :disabled="isBusy"
                    ><i class="fas fa-search text-white fa-lg"></i>Lọc
                  </b-button>
                </b-button-group>
              </b-col>
              <b-col md="3"></b-col>
            </b-row>
            <b-row class="mb-5">
              <b-col md="3">
                <b-form-input
                  size="sm"
                  v-model="queryParams.batchCode"
                  placeholder="Tìm kiếm mã lô"
                  v-on:keyup.enter="onFilter()"
                ></b-form-input>
              </b-col>
              <b-col md="3">
                <BDropdownCustom
                  v-model="stockStatusValues"
                  :options="optionsStockStatus"
                  :placeholder="'trạng thái tồn'"
                  :matchKey="['name']"
                  :searchable="false"
                  :limit="5"
                />
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col class="d-flex justify-content-end align-items-center flex-wrap">
                <span class="mr-3">
                  <i class="fas fa-circle fa-sm text-dark"></i>
                  Tồn có thể bán
                </span>
                <span class="mr-3">
                  <i class="fas fa-circle fa-sm text-primary"></i>
                  Đang chuyển kho
                </span>
                <span class="mr-3">
                  <i class="fas fa-circle fa-sm text-warning"></i>
                  Đang bảo hành
                </span>
                <span class="mr-3">
                  <i class="fas fa-circle fa-sm text-info"></i>
                  Đang giữ hàng
                </span>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-table
                  :items="data"
                  :fields="fields"
                  :busy="isBusy"
                  bordered
                  hover
                  class="table-bordered table-hover col-md-12"
                >
                  <template #table-busy>
                    <div class="text-center text-dark my-2">
                      <b-spinner class="align-middle mr-2"></b-spinner>
                      <strong>Đang tải...</strong>
                    </div>
                  </template>
                  <template #cell(productName)="row">
                    <div v-if="row.item.barCode">
                      <span
                        v-b-tooltip.hover.top="'Bar code'"
                        class="d-inline-block"
                        style="white-space: normal; font-size: 12px; font-weight: 500"
                        >{{ row.item.barCode }}</span>
                    </div>
                    <div v-if="row.item.productId">
                      <span
                        v-b-tooltip.hover.top="'Product Id'"
                        class="d-inline-block"
                        style="font-size: 12px; font-weight: 500"
                        >{{ row.item.productId }}</span>
                    </div>
                    <div>
                      <b
                        v-b-tooltip.hover.top="'Product name'"
                        class="d-inline-block"
                        style="white-space: normal"
                        >{{ row.item.productName }}</b>
                    </div>
                  </template>
                  <template v-slot:cell(quantity)="row">
                    <div style="text-align: end">
                      <b
                        v-text="row.item.quantity.inStockQuantity"
                        class="mr-1"
                        v-b-tooltip.hover.top
                        title="Tồn có thể bán"
                      >
                      </b>
                      <b
                        class="text-primary mr-1 font-size-setting"
                        v-if="row.item.quantity.transferQuantity"
                        v-b-tooltip.hover.top
                        title="Đang chuyển kho"
                      >
                        {{ '+' + row.item.quantity.transferQuantity }}
                      </b>
                      <b
                        class="text-warning mr-1 font-size-setting"
                        v-if="row.item.quantity.warrantyQuantity"
                        v-b-tooltip.hover.top
                        title="Đang bảo hành"
                      >
                        {{ '+' + row.item.quantity.warrantyQuantity }}
                      </b>
                      <b
                        class="text-info mr-1 font-size-setting"
                        v-if="row.item.quantity.holdingQuantity"
                        v-b-tooltip.hover.top
                        title="Đang giữ hàng"
                      >
                        {{ '+' + row.item.quantity.holdingQuantity }}
                      </b>
                    </div>
                  </template>
                  <template v-slot:cell(actions)="row">
                    <div class="d-flex justify-content-center">
                      <b-dropdown
                        size="sm"
                        :id="'dropdown-batch-' + row.item.id"
                        no-caret
                        right
                      >
                        <template slot="button-content">
                          <i
                            style="font-size: 1rem; padding-right: 0px"
                            class="flaticon2-settings"
                          ></i>
                        </template>
                        <b-dropdown-item @click="goToHistory(row.item)">
                          <span style="color: #3f4254; font-size: 12px">
                            <i
                              style="font-size: 1rem"
                              class="fa fa-history"
                            ></i>
                            &nbsp; Xem lịch sử
                          </span>
                        </b-dropdown-item>
                        <b-dropdown-item @click="printBatch(row.item)">
                          <span style="color: #3f4254; font-size: 12px">
                            <i
                              style="font-size: 1rem"
                              class="flaticon2-printer"
                            ></i>
                            &nbsp; In lô hàng
                          </span>
                        </b-dropdown-item>
                      </b-dropdown>
                    </div>
                  </template>
                  <!-- Dòng Tổng cộng: SUM toàn bộ dòng khớp filter (mọi trang) từ API `totals`,
                       KHÔNG tự cộng client (client chỉ có 1 trang). -->
                  <template v-if="totals" v-slot:custom-foot>
                    <tr class="batch-total-row font-weight-bolder">
                      <td colspan="3" class="text-right">Tổng cộng</td>
                      <td class="text-right">
                        <b
                          class="mr-1"
                          v-b-tooltip.hover.top
                          title="Tồn có thể bán"
                          >{{ totals.inStockQuantity }}</b>
                        <b
                          class="text-primary mr-1"
                          v-if="totals.transferQuantity"
                          v-b-tooltip.hover.top
                          title="Đang chuyển kho"
                          >{{ '+' + totals.transferQuantity }}</b>
                        <b
                          class="text-warning mr-1"
                          v-if="totals.warrantyQuantity"
                          v-b-tooltip.hover.top
                          title="Đang bảo hành"
                          >{{ '+' + totals.warrantyQuantity }}</b>
                        <b
                          class="text-info mr-1"
                          v-if="totals.holdingQuantity"
                          v-b-tooltip.hover.top
                          title="Đang giữ hàng"
                          >{{ '+' + totals.holdingQuantity }}</b>
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <p class="mt-3 text-dark font-weight-bold">
                  Hiển thị {{ startIndex }} - {{ endIndex }} trong số
                  {{ totalItems }} bản ghi
                </p>
              </b-col>
              <b-col>
                <b-pagination
                  pills
                  v-show="totalPages >= 2"
                  v-model="queryParams.page"
                  :total-rows="totalItems"
                  :per-page="queryParams.limit"
                  @change="handlePageChange"
                  align="right"
                  class="mt-3"
                  style="border-radius: 5px"
                ></b-pagination>
              </b-col>
            </b-row>
          </b-col>
        </div>
      </template>
    </KTCodePreview>

    <ListProductBatchStockHistory
      :visible.sync="historyModal.visible"
      :product-batch-stock-id="historyModal.id"
      :batch-code="historyModal.batchCode"
      :product-name="historyModal.productName"
    />
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service';
import { handleError, makeToastSuccess, makeToastFaile } from '@/utils/common';
import fileDownload from '@/utils/file-download';
import { ProductBatchQueryParams } from '@/view/pages/product-batch-stock/models/ProductBatchQueryParams';
import { SUCCESS_RESPONSE_STATUS } from '@/utils/constants';
import { ProductBatchStock } from '@/view/pages/product-batch-stock/models/ProductBatchStock';
import {
  PRODUCT_BATCH_TABLE_HEADERS,
  BATCH_STOCK_STATUS_OPTIONS,
} from '@/view/pages/product-batch-stock/constants/table';
import KTCodePreview from '@/view/content/CodePreview.vue';
import { DP_CONFIG } from '@/utils/date';
import { VueAutosuggest } from 'vue-autosuggest';
import BDropdownCustom from '@/view/base/bootstrap/BDropdownCustom.vue';
import ListProductBatchStockHistory from '@/view/pages/product-batch-stock/ListProductBatchStockHistory.vue';
import {
  paginationMixin,
  productSearchMixin,
  storeSearchMixin,
} from '@/view/mixins';
import { formatDBDate, getSubtractDate } from '@/utils/date';

export default {
  components: {
    BDropdownCustom,
    KTCodePreview,
    VueAutosuggest,
    ListProductBatchStockHistory,
  },
  mixins: [productSearchMixin, storeSearchMixin, paginationMixin],
  data() {
    return {
      data: [],
      totals: null,
      isDownloading: false,
      fields: PRODUCT_BATCH_TABLE_HEADERS,
      isBusy: false,
      dpConfigs: DP_CONFIG,
      // clone để mỗi lần mount không giữ trạng thái checked cũ
      optionsStockStatus: BATCH_STOCK_STATUS_OPTIONS.map((option) => ({
        ...option,
      })),
      stockStatusValues: [],
      historyModal: {
        visible: false,
        id: null,
        batchCode: '',
        productName: '',
      },

      queryParams: new ProductBatchQueryParams({
        fromDate: getSubtractDate(30),
      }),
    };
  },
  computed: {
    startIndex() {
      return (this.queryParams.page - 1) * this.queryParams.limit + 1;
    },
    endIndex() {
      return this.queryParams.page * this.queryParams.limit;
    },
  },
  mounted() {
    this.fetchProduct();
  },
  methods: {
    afterFetchStore() {
      this.fetchProductBatches();
    },
    fetchProductBatches() {
      if(this.isBusy) return;
      this.isBusy = true
      const params = this.getParamsFilter();
      ApiService.query('product-batch-stock', { params })
        .then(this.handleMappingResult)
        .catch((error) => handleError(error))
        .finally(()=> this.isBusy = false)
    },
    getParamsFilter() {
      return {
        ...this.queryParams,
        storeIds: this.storeValues.map((storeValue) => storeValue.id),
        stockStatus: this.stockStatusValues.map((status) => status.code),
        fromDate: formatDBDate(this.queryParams.fromDate),
        toDate: formatDBDate(this.queryParams.toDate),
      };
    },
    handlePageChange(pageNum) {
      this.queryParams.page = pageNum ? parseInt(pageNum) : 1;
      this.fetchProductBatches();
    },
    handleMappingResult({ data }) {
      if (data.status === SUCCESS_RESPONSE_STATUS) {
        this.data = data.data.result.map((productBatch) => {
          productBatch.quantity = {
            inStockQuantity: productBatch.inStockQuantity,
            transferQuantity: productBatch.transferQuantity,
            warrantyQuantity: productBatch.warrantyQuantity,
            holdingQuantity: productBatch.holdingQuantity,
          };
          return Object.assign({}, new ProductBatchStock(productBatch));
        });
        // Totals SUM toàn bộ dòng khớp filter (mọi trang) do BE trả về.
        this.totals = data.data.totals || null;
        this.mapPagination(data);
      }
    },
    async exportExcel() {
      if (this.isDownloading) return;
      this.isDownloading = true;
      try {
        const params = this.getParamsFilter();
        const response = await ApiService.query('product-batch-stock/export-excel', {
          params,
          responseType: 'blob',
        });
        const fileName = fileDownload.getFileName(response);
        fileDownload.createFile(response.data, fileName);
        makeToastSuccess('Xuất Excel thành công');
      } catch (error) {
        makeToastFaile('Xuất Excel thất bại');
      } finally {
        this.isDownloading = false;
      }
    },
    getSuggestionValue(suggestion) {
      return suggestion.item.productName;
    },
    onFilter() {
      this.queryParams.page = 1;
      this.fetchProductBatches();
    },
    goToHistory(item) {
      this.historyModal = {
        visible: true,
        id: item.id,
        batchCode: item.batchCode || '',
        productName: item.productName || '',
      };
    },
    printBatch(item) {
      this.$router.push({
        name: 'print-product-qrcode',
        query: { productBatchStockId: item.id },
      });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.icon-font-size {
  font-size: 1rem;
}

.icon-wrapper-font-size {
  font-size: 12px;
}

.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
}

input:focus {
  outline: none !important;
  border: 1px solid #92c5f9;
}

select {
  height: 2.5em;
}

.example {
  border: 1px solid #ddd;
  margin-bottom: 2em;
}

code,
pre {
  margin: 1em 0;
  padding: 1em;
  border: 1px solid #bbb;
  display: block;
  background: #ddd;
  border-radius: 3px;
}

.settings {
  margin: 2em 0;
  border-top: 1px solid #bbb;
  background: #eee;
}

/* h5 {
  font-size: 100%;
  padding: 0;
} */

.form-group {
  margin-bottom: 1em;
}

.btn.btn-icon.btn-sm,
.btn-group-sm > .btn.btn-icon {
  height: calc(1.35em + 1.1rem + 2px);
  width: auto;
}

.icon:hover {
  background-color: #90c6fc;
}

.autosuggest__results ul {
  list-style: none;
  cursor: pointer;
  margin-bottom: 0;
}

.autosuggest__results {
  position: absolute;
  background-color: #fff;
  z-index: 1;
  width: 100%;
  border: 1px solid #e0e0e0;
}

.autosuggest__results-container {
  position: relative;
  width: 100%;
}

#autosuggest__input {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  height: calc(1.35em + 1.1rem + 2px);
  padding: 0.55rem 0.75rem;
  font-size: 0.925rem;
  line-height: 1.35;
  border-radius: 0.28rem;
}

#autosuggest__input:focus {
  outline: none !important;
  border: 1px solid #92c5f9;
}

.autosuggest__results-item:hover {
  background-color: #ddd;
}

.autosuggest__results ul li {
  padding: 8px;
}

::-webkit-datetime-edit-year-field:not([aria-valuenow]),
::-webkit-datetime-edit-month-field:not([aria-valuenow]),
::-webkit-datetime-edit-day-field:not([aria-valuenow]) {
  color: transparent;
}

.productCode:hover {
  text-decoration: underline;
}

.test {
  position: absolute;
  right: 1vw;
}

.checkbox-label {
  display: block;
}

.multiselect {
  min-height: initial;
}

.multiselect__tags {
  display: block;
  padding: 3px 40px 0 8px;
  border-radius: 5px;
  border: 1px solid #e8e8e8;
  background: #fff;
  font-size: 12px;
  min-height: initial;
}

.multiselect__element {
  min-height: initial;
  display: block;
  background: #fff;
  font-size: 12px;
}

.multiselect__input {
  min-height: initial;
  display: block;
  background: #fff;
  font-size: 12px;
}

.multiselect__single {
  font-size: 12px;
}

.text-imei-no {
  font-size: 12px;
  font-style: italic;
  color: dodgerblue;
}

.date-style {
  display: flex;
  align-items: center;
}

.batch-stock-list thead th {
  text-align: center !important;
  vertical-align: middle;
}

.form-group {
  margin-bottom: 1em;
}
</style>
